module.exports = __webpack_public_path__ + "static/media/limocious.9da96bd2.png";